import { useEffect, useState } from 'react'
import './toast.css'
export default function Toast({ text, onClose, ms=2600 }) {
    const [show,setShow]=useState(true)
    useEffect(()=>{ const t=setTimeout(()=>{ setShow(false); setTimeout(onClose,200) },ms); return ()=>clearTimeout(t) },[ms,onClose])
    if(!show) return null
    return <div className="toast">{text}</div>
}
